import axios from 'axios'

export default {
    getIcareCategory(){
        return axios.get('/icare-category')
            .then(response => {
                return response.data
            })
    },
    getIcareCategoryDataSource(params){
        return axios.get('/icare-category/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareCategorybyID(id){
        return axios.get('/icare-category/' + id)
            .then(response => {
                return response.data
            })
    },
    createIcareCategory(formdata){
        return axios.post('/icare-category', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcareCategory(id,formdata){
        return axios.put('/icare-category/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateIcareCategory(id){
        return axios.put('/icare-category/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateIcareCategory(id){
        return axios.put('/icare-category/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    getIcareAgeRange(){
        return axios.get('/icare/age-range')
            .then(response => {
                return response.data
            })
    },

}
